import { PageName } from '@amzn/atoz-shiftapp-initializer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = (page: PageName | undefined) => {
    const { t } = useTranslation();

    useEffect(() => {
        const title = (() => {
            switch (page) {
                case PageName.Dashboard:
                case PageName.MySchedule:
                    return t('shift_management_features_mySchedule_pageTitle');
                case PageName.FindShifts:
                    return t('shift_management_features_findShifts_pageTitle');
                case PageName.LocationEligibility:
                    return t(
                        'shift_management_features_locationEligibility_pageTitle'
                    );
                case PageName.Swap:
                    return t('shift_management_features_swaps_pageTitle');
                default:
                    return undefined;
            }
        })();
        if (title) {
            document.title = title;
        }
    }, [t, page]);
};
